module.exports = __webpack_public_path__ + "static/media/contact-email.8ecf4d6c.png";